import { EmailTextField } from "@/components/Form/EmailTextField";
import { auth } from "@/libs/firebase";
import { caremeTheme } from "@/libs/theme";
import { Box, Button, TextField } from "@mui/material";
import { FirebaseError } from "firebase/app";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";

export function EmailAndPasswordSignInForm() {
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		setSubmitting(true);

		const data = new FormData(e.currentTarget);
		const email = (data.get("email") || "") as string;
		const password = (data.get("password") || "") as string;

		try {
			await signInWithEmailAndPassword(auth, email, password);
		} catch (e) {
			if (e instanceof FirebaseError) {
				switch (e.code) {
					case "auth/user-not-found": {
						window.alert("このメールアドレスのユーザーは存在しません");
						return;
					}
					case "auth/invalid-email": {
						window.alert("メールアドレスの形式が正しくありません。");
						return;
					}
					case "auth/wrong-password": {
						window.alert("パスワードが間違っています");
						return;
					}
					case "auth/internal-error": {
						window.alert(
							"エラーが発生しました。メールアドレスとパスワードが正しいか再度ご確認だくさい。",
						);
						return;
					}
				}
			}
			return;
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Box component="form" onSubmit={handleSubmit}>
			<EmailTextField />
			<TextField
				margin="normal"
				required
				fullWidth
				name="password"
				type="password"
				autoComplete="current-password"
				variant="standard"
				placeholder="パスワード"
				style={{ caretColor: caremeTheme.palette.primary.main }}
			/>
			<Button
				type="submit"
				fullWidth
				variant="contained"
				sx={{ mt: 3 }}
				disabled={submitting}
			>
				ログインする
			</Button>
		</Box>
	);
}
